import { render, staticRenderFns } from "./SplashVideo.vue?vue&type=template&id=98475d1a"
import script from "./SplashVideo.vue?vue&type=script&lang=js"
export * from "./SplashVideo.vue?vue&type=script&lang=js"
import style0 from "./SplashVideo.vue?vue&type=style&index=0&id=98475d1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports